import create from 'zustand/vanilla';

interface MallState {
    id: string,
    name: string,
    description: string,
    backgroundColor?: string,
    backgroundImage?: string,
    profileImage?: string,
    mallPath?: string,
}

export interface MallStore extends MallState {
    setCurrentMall: (session: MallState) => void;
    clearCurrentMall: () => void;
}

const initializeState: MallState = {
    id: '',
    name: '',
    description: '',
    backgroundColor: '',
    backgroundImage: '',
    profileImage: '',
    mallPath: '',
}

export const currentMallStore = create<MallStore>((set) => ({
    ...initializeState,

    setCurrentMall: (state) => {
        const initState: MallState = {...initializeState};
        const nState: Record<string, any> = {};

        Object.entries(initState).forEach(([key, value]) => {
            nState[key] = state[key as keyof MallState] || value;
        })

        set((state) => nState);
    },

    clearCurrentMall: () => {
        set(initializeState);
    }
}));

const { getState, setState, subscribe, destroy } = currentMallStore;

export default currentMallStore;